import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-header-logged-out',
  templateUrl: './client-header-logged-out.component.html',
  styleUrls: ['./client-header-logged-out.component.scss']
})
export class ClientHeaderLoggedOutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
